<template>
    <div class="main-view ml-0">
        <v-container class="parts-container pa-0 ma-0" v-if="isPartListVisible" fluid>
            <v-card class="d-flex align-content-start flex-wrap" flat color="transparent" tile>
                <div class="part-wrapper part" v-for="part in project.currentLevelParts" :key="part.id"
                    @click="selectPartOrRootDrawingById(part.id)" :title="part.id">
                    <div class="part-wrapper-image">
                        <img :src="part.thumbUrl" class="part-img" />
                    </div>
                    <div class="part-wrapper-text theme-thumbfontcolor theme-thumbbackcolor theme-thumbfontname">
                        <span>{{ part.data.name }}</span>
                        <span v-if="part.showRev" class="revision">{{ part.data.revision }}</span>
                    </div>
                </div>
            </v-card>
        </v-container>

        <v-container class="parts-container pa-0 ma-0" v-if="isDrawingListVisible" fluid>
            <v-card class="d-flex align-content-start flex-wrap" flat color="transparent" tile>
                <div v-for="drw in project.currentLevelDrawings" :key="drw.id">
                    <div class="part-wrapper drawing" @click="showExplodedViewOrSubAssemblies(drw.id)">
                        <div class="part-wrapper-image">
                            <img :src="drw.thumbUrl" />
                        </div>
                        <div class="part-wrapper-text theme-thumbfontcolor theme-thumbbackcolor theme-thumbfontname">
                            <span>{{ drw.name }}</span>
                        </div>
                    </div>
                    <div class="part-miniature">
                        <div v-if="project.drawingMap[drw.id].hasChildren && project.uxd.showthumbsubassynav == 'true'"
                            class="part-miniature-active" :title="project.uxd.labelshowsubassemblies"
                            @click="showSubassemblies(drw.id)">

                            <div class="part-miniature-container" style="top:0;left:0px;">
                                <div class="part-miniature-cube">
                                    <v-icon>mdi-sitemap-outline</v-icon>
                                </div>
                                <div class="part-miniature-cube-label part-miniature-color">
                                </div>
                            </div>
                            <div class="part-miniature-container" style="top:0;left:46px;">
                                <div class="part-miniature-cube">
                                    <v-icon>mdi-sitemap-outline</v-icon>
                                </div>
                                <div class="part-miniature-cube-label part-miniature-color">
                                </div>
                            </div>
                            <div class="part-miniature-container" style="top:0;left:90px">
                                <div class="part-miniature-childcount">
                                    <span class="part-miniature-childcounttext theme-fontname">{{ drw.childCount
                                        }}</span>
                                </div>
                                <div style="width:40px;height:8px;position:relative;">
                                    <div class="part-miniature-circle part-miniature-color"
                                        style="position:absolute;left:5px;top:1px;"></div>
                                    <div class="part-miniature-circle part-miniature-color"
                                        style="position:absolute;left:16px;top:1px"></div>
                                    <div class="part-miniature-circle part-miniature-color"
                                        style="position:absolute;left:27px;top:1px"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </v-card>
        </v-container>

        <search-result v-if="project.searchVisible"></search-result>

        <drawing-view v-show="isDrawingVisible" ref="drawing" v-on:hotspot-clicked="hotSpotClicked"
            style="position: relative;height: 100%"></drawing-view>
        <details-view v-if="isDrawingVisible && !project.searchVisible" class="details-view"
            ref="detailsView"></details-view>

        <v-snackbar v-model="snackbar">
            {{ msg }}
            <v-btn color="red" text @click="snackbar = false">
                Close
            </v-btn>
        </v-snackbar>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import Drawing from './Drawing.vue'
import DetailsView from './DetailsView.vue'
import $ from 'jquery'
import SearchResult from './SearchResult'

export default {
    name: 'MainView',
    data() {
        return {
            size: 3,
            msg: '',
            projectViewActive: true,
            drawingsViewActive: false,
            snackbar: false,
        }
    },
    components: {
        'search-result': SearchResult,
        'drawing-view': Drawing,
        'details-view': DetailsView
    },
    watch: {
        $route(to) {
            this.handleRoute(to);
        }
    },
    computed: {
        ...mapState([
            'project',
            'session'
        ]),
        ...mapGetters([
            'isInitialized',
            'isPartSelected',
            'parentPartId',
            'selectedPartId',
            'selectedDrawingId',
            'isPartListVisible',
            'isDrawingListVisible',
            'isDrawingVisible'
        ])
    },
    methods: {
        ...mapActions([
            'getPubTree',
            'selectPart',
            'goToRoot',
            'selectPartOrRootDrawingById',
            'selectParentPart',
            'selectPartById',
            'showHotspotByDrawingAndHotspotId',
            'showHotspotById',
            'showDrawing',
            'selectDrawing',
            'selectDrawingById',
            'openDrawer',
            'hideDrawer',
            'getFeatures',
            'getLocales',
            'restoreViewState',
            'restoreExpansionState',
            'showDrawingById',
            'showExplodedViewOrSubAssemblies',
            'showSubassemblies'
        ]),
        hotSpotClicked() {
            if (this.$refs.detailsView !== undefined) {
                this.$refs.detailsView.openDetails()
            }
        },
        showSelectedHotspot() {
            this.$refs.drawing.showSelectedHotspot()
        },
        showExplodedViewOrSubAssemblies(drwId) {
            let drw = this.project.drawingMap[drwId];
            // eslint-disable-next-line no-console
            // console.log(this.project.uxd.thumbnavtosubassyonlylinks);
            if (drw.hasChildren &&
                ((this.project.uxd.thumbnavtosubassy == 'true' && drw.hscount == 0) ||
                (this.project.uxd.thumbnavtosubassynoarticle == 'true' && drw.oemcount == 0) ||
                (this.project.uxd.thumbnavtosubassyonlylinks == 'true' && drw.linkcount == drw.funccount) 
                )) {
                this.selectDrawingById(drwId);
            }
            else {
                this.showDrawingById(drw.id);
            }
        },
        showSubassemblies(drwId) {
            let drw = this.project.drawingMap[drwId];
            if (drw.hasChildren) {
                this.selectDrawingById(drw.id);
            }
        },
        doSelectHotSpot(id) {
            this.selectHotSpot(id)
            if (id === null) {
                $('svg .pcg_hotspot').removeClass('selected')
            }
        },
        async start() {

            if (this.isInitialized) {
                await this.getFeatures();
                await this.getLocales();
                await this.getPubTree();
                await this.restoreViewState();
                await this.restoreExpansionState();
            } else {
                this.msg = 'app is not initilized (missing token ?)'
                this.snackbar = true;
            }
        },
        selectedDrawingStyleMain() {
            return 'border:2px solid ' + this.project.uxd.listseltext
        },
        selectedDrawingStyleSub() {
            return 'border:2px solid ' + this.project.uxd.listselback2
        }
    },
    created: function () {
        this.start()
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fade-leave-active,
.fade-enter-active {
    transition: all .2s;
    transition-timing-function: linear;
}

.fade-enter {
    transform: translateY(-260px);
    opacity: 0;
}

.fade-leave-to {
    transform: translateY(260px);
    opacity: 0;
}

.details-enter-active {
    transition: all .6s;
    transition-timing-function: linear;
}

.details-enter {
    transform: translateY(180px);
    opacity: 0;
}

.details-leave-to {
    transform: translateY(-180px);
    opacity: 100%;
}
</style>
